// File: frontend/src/config/api.js

const ENV = process.env.REACT_APP_APP_ENV || 'dev';

const CONFIG = {
  dev: {
    apiUrl: process.env.REACT_APP_API_URL || 'https://api.dev.allegoryos.com',
    wsUrl: process.env.REACT_APP_WS_URL || 'wss://ws.dev.allegoryos.com',
    appUrl: process.env.REACT_APP_APP_URL || 'https://preview-allegoryinsurance-web.dev.allegoryos.com'
  },
  prod: {
    apiUrl: process.env.REACT_APP_API_URL || 'https://api.allegoryos.com',
    wsUrl: process.env.REACT_APP_WS_URL || 'wss://ws.allegoryos.com',
    appUrl: process.env.REACT_APP_APP_URL || 'https://allegoryinsurance.com'
  }
};

const currentConfig = CONFIG[ENV] || CONFIG.dev;

export const API_CONFIG = {
  baseUrl: currentConfig.apiUrl,
  wsUrl: currentConfig.wsUrl,
  appUrl: currentConfig.appUrl,
  enterpriseId: process.env.REACT_APP_ENTERPRISE_ID,
  environment: ENV,
  siteName: process.env.REACT_APP_SITE_NAME || 'AllegoryOS'
};

export default API_CONFIG;
